import type { UserDetailMode } from '@features/users/components/detail-panel/UserDetailPanel.types';

import { UserDetailPanel } from '@features/users/components/detail-panel/UserDetailPanel';
import { useUserNavigation } from '@features/users/hooks/use-user-navigation/useUserNavigation';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

const UserCreateRoute = React.memo((): React.ReactElement => {
  const { navigateToUsersList } = useUserNavigation();
  const location = useLocation();

  const sfPrefillData = (
    location.state as { sfPrefillData?: Record<string, string> }
  )?.sfPrefillData;

  const mode: UserDetailMode = sfPrefillData ? 'sf-add' : 'add';

  return (
    <UserDetailPanel
      mode={mode}
      initialData={sfPrefillData}
      onClose={navigateToUsersList}
    />
  );
});

UserCreateRoute.displayName = 'UserCreateRoute';

export { UserCreateRoute };
